import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

export const payrollInputKindV1Schema = z.enum([
  "employee_time",
  "contractor_hourly",
  "contractor_job",
])

export const payrollInputStateV1Schema = z.enum([
  "Draft",
  "Approved",
  "Submitted",
])

export const payrollInputPrepareV1Schema = z
  .object({
    inputId: entityIdSchema,
    workShiftId: entityIdSchema,
    sourceShiftVersion: z.number().int().positive(),
    workerId: entityIdSchema,
    relationshipId: entityIdSchema,
    payrollProfileId: entityIdSchema,
    kind: payrollInputKindV1Schema,
    jobReference: z.string().trim().min(1).max(120).nullable(),
    amountMinor: z.number().int().positive().nullable(),
    currency: z.string().regex(/^[A-Z]{3}$/).nullable(),
    correctionReason: z.string().trim().min(1).max(500).nullable(),
  })
  .strict()
  .superRefine((value, context) => {
    const job = value.kind === "contractor_job"
    if (
      job !==
      (value.jobReference !== null &&
        value.amountMinor !== null &&
        value.currency !== null)
    ) {
      context.addIssue({
        code: "custom",
        path: ["kind"],
        message: "Only contractor job inputs carry job money.",
      })
    }
    if (
      !job &&
      (value.jobReference !== null ||
        value.amountMinor !== null ||
        value.currency !== null)
    ) {
      context.addIssue({
        code: "custom",
        path: ["kind"],
        message: "Time inputs cannot carry job money.",
      })
    }
  })

export const payrollInputApproveV1Schema = z
  .object({
    inputId: entityIdSchema,
    reason: z.string().trim().min(1).max(500),
  })
  .strict()

export const payrollInputResultV1Schema = z
  .object({
    entityType: z.literal("payroll_input"),
    entityId: entityIdSchema,
    state: payrollInputStateV1Schema,
    version: z.number().int().positive(),
    workShiftId: entityIdSchema,
    sourceShiftVersion: z.number().int().positive(),
    workerId: entityIdSchema,
    relationshipId: entityIdSchema,
    payrollProfileId: entityIdSchema,
    legalEntityId: entityIdSchema,
    branchId: entityIdSchema,
    kind: payrollInputKindV1Schema,
    minutes: z.number().int().positive().nullable(),
    jobReference: z.string().min(1).max(120).nullable(),
    amountMinor: z.number().int().positive().nullable(),
    currency: z.string().regex(/^[A-Z]{3}$/).nullable(),
    immutableAtSubmission: z.literal(true),
  })
  .strict()

export type PayrollInputPrepareV1 = z.infer<typeof payrollInputPrepareV1Schema>
export type PayrollInputApproveV1 = z.infer<typeof payrollInputApproveV1Schema>
export type PayrollInputResultV1 = z.infer<typeof payrollInputResultV1Schema>
